import fetch from 'isomorphic-fetch'
import ApplicationConf from '../../../../conf/ApplicationConf'
import { callPromisesSequentially, checkAuth, genericPromise2, getAuthorization, getJson } from '../../../../utils/ActionUtils'
import ToastrAction from 'toastr/actions/ToastrAction'
import i18n from 'simple-react-i18n'
import LogAction from '../../../../log/actions/LogAction'
import { zip } from 'lodash'
import { ManagementUnitActionConstant } from '../reducers/ManagementUnitReducer'

const ManagementUnitAction = {
    fetchManagementUnit(id) {
        return (dispatch) => {
            return fetch(ApplicationConf.referencial.getManagementUnit(id), {
                method: 'GET',
                headers: getAuthorization(),
            })
                .then(checkAuth)
                .then(getJson)
                .then((json = []) => {
                    dispatch(ManagementUnitActionConstant.managementUnit(json))
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.fetchError + i18n.managementUnit} : ${err}`))
                    dispatch(ToastrAction.error(i18n.fetchError + i18n.managementUnit))
                })
        }
    },

    fetchManagementUnits: () => dispatch => {
        return fetch(ApplicationConf.referencial.getAllManagementUnits(), {
            method: 'GET',
            headers: getAuthorization(),
        })
            .then(checkAuth)
            .then(getJson)
            .then(json => {
                dispatch(ManagementUnitActionConstant.managementUnits(json))
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError + i18n.managementUnit} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError + i18n.managementUnit))
            })
    },

    fetchManagementUnitsRestrictions: () => dispatch => {
        return fetch(ApplicationConf.referencial.managementUnitsRestrictions(), {
            method: 'GET',
            headers: getAuthorization(),
        })
            .then(checkAuth)
            .then(getJson)
            .then(json => {
                dispatch(ManagementUnitActionConstant.managementUnitsRestrictions(json))
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError + i18n.managementUnit} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError + i18n.managementUnit))
            })
    },

    updateManagementUnitsRestrictions: (managementUnitsRestrictions) => dispatch => {
        return fetch(ApplicationConf.referencial.managementUnitsRestrictions(), {
            method: 'PUT',
            headers: getAuthorization(),
            body: JSON.stringify(managementUnitsRestrictions),
        })
            .then(checkAuth)
            .then(getJson)
            .then(json => {
                if (!json.error) {
                    dispatch(ToastrAction.success(i18n.elementUpdateSuccess))
                } else {
                    throw new Error()
                }
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError + i18n.restrictions} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError + i18n.restrictions))
            })
    },

    createManagementUnit: (managementUnit) => dispatch => {
        return fetch(ApplicationConf.referencial.createManagementUnit(), {
            method: 'POST',
            headers: getAuthorization(),
            body: JSON.stringify(managementUnit),
        })
            .then(checkAuth)
            .then(getJson)
            .then(json => {
                if (json.insert === 1) {
                    dispatch(ToastrAction.success(i18n.unitSuccessUpdated))
                    return json.id
                }
                throw new Error()
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError + i18n.managementUnit} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError + i18n.managementUnit))
            })
    },

    updateManagementUnit: (managementUnit) => dispatch => {
        return fetch(ApplicationConf.referencial.updateManagementUnit(), {
            method: 'PUT',
            headers: getAuthorization(),
            body: JSON.stringify(managementUnit),
        })
            .then(checkAuth)
            .then(getJson)
            .then(json => {
                if (json.update >= 1) {
                    dispatch(ToastrAction.success(i18n.unitSuccessUpdated))
                } else {
                    throw new Error()
                }
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError + i18n.managementUnit} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError + i18n.managementUnit))
            })
    },

    getSubManagementUnitsDetailsVolumesSequentially(managementUnits, date, endDate, signal, callBackEnd) {
        return dispatch => {
            const [promises, params] = zip(...managementUnits.map(managementUnit => (
                [
                    ManagementUnitAction.fetchSubManagementUnitsDetailsVolumesByDate,
                    [managementUnit.managementCode, date, endDate, signal, dispatch],
                ]
            )))
            return callPromisesSequentially(promises, params, () => { }, callBackEnd)
        }
    },

    fetchSubManagementUnitsDetailsVolumesByDate: (id, date, endDate, signal, dispatch) =>
        genericPromise2(ApplicationConf.agri.getSubManagementUnitsDetailsVolumesByDate(id, date, endDate), { signal })
            .then((json = {}) => {
                dispatch(ManagementUnitActionConstant.managementUnitsVolumes({ managementUnitVolumes: json, idUG: id }))
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError + i18n.volumes} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError + i18n.volumes))
            }),
}

export default ManagementUnitAction
